import { computed, makeAutoObservable, observable } from 'mobx';
import { RecordCard } from '../RecordCard';
import { CardOptions, RecordCardServices } from '../RecordCard/types';
import { RecordLayer } from '../RecordCard/RecordLayer';
import OlMap from 'ol/Map';

export class RecordCardManager {
  private _cardsCache = new Map<string, RecordCard>();
  @observable private _collection: Set<RecordCard> = new Set();
  private _services: RecordCardServices;

  constructor(services: RecordCardServices) {
    this._services = services;
    makeAutoObservable(this);
  }

  @computed get collection() {
    return [...this._collection.values()];
  }

  createCard(
    tableName: string,
    recordId: number | string,
    options?: Partial<CardOptions>,
  ) {
    const key = this._buildKey(tableName, recordId);
    let card = this._cardsCache.get(key);

    if (!card) {
      card = new RecordCard(this._services, tableName, recordId, options);
      this._cardsCache.set(key, card);
      card.load();
    }

    return card;
  }

  createFeatureLayer(card: RecordCard, map: OlMap) {
    return new RecordLayer(card, map);
  }

  addCardToCollection(card: RecordCard) {
    this._collection.add(card);
  }

  deleteCardFromCollection(card: RecordCard) {
    this._collection.delete(card);
  }

  private _buildKey(tableName: string, recordId: number | string) {
    return `${tableName}-${recordId}`;
  }
}
